"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.csrf = exports.Csrf = void 0;

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var Csrf = /*#__PURE__*/function () {
  function Csrf() {
    (0, _classCallCheck2.default)(this, Csrf);
    this._token = void 0;
  }

  (0, _createClass2.default)(Csrf, [{
    key: "getToken",
    value: function getToken() {
      return this._token;
    }
  }, {
    key: "init",
    value: function init() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;

      try {
        var url = new _url.default(location.href);

        if (url.searchParams.has('csrf_token')) {
          var csrfToken = url.searchParams.get('csrf_token'); // url.searchParams.delete('csrf_token');

          history.replaceState(undefined, '', url.toString());

          if (csrfToken) {
            this._token = csrfToken;
          }
        }
      } catch (error) {//
      }
    }
  }]);
  return Csrf;
}();

exports.Csrf = Csrf;
var csrf = new Csrf();
exports.csrf = csrf;